// src/pages/battle/components/CombatLog.jsx
import React from 'react';
import { Zap } from 'lucide-react';

const CombatLog = ({ log }) => {
  return (
    <div className="bg-gray-800 border border-gray-700 rounded-lg p-4">
      <h3 className="font-bold mb-3 flex items-center gap-2">
        <Zap className="text-yellow-400" size={18} />
        COMBAT LOG
      </h3>
      <div className="space-y-1">
        {log.map((entry, i) => (
          <div 
            key={i} 
            className="text-xs text-gray-300 font-mono bg-gray-900/50 rounded px-2 py-1"
          >
            {entry}
          </div>
        ))}
      </div>
    </div>
  );
};

export default CombatLog;